import React from "react";
import { Row, Form, Col } from "react-bootstrap";

import CountrySelect, { exists as CountryValid, label as CountryLabel } from "../../select/country"
import CountySelect, { exists as CountyValid } from "../../select/county";
import StateSelect, { exists as StateValid, label as StateLabel } from "../../select/state";
import OptionCard from "../../option-card";
import { deepEqual } from "../../../utils/object";

class Location extends React.Component {
    /**
     *
     */
    constructor(props) {
        super(props);
        this.state = {
            configuration: { ...props.meta },
            data: props.data ?? {
                country: props.meta?.defaults?.country,
                state: props.meta?.defaults?.state
            },
            label: props.label,
            locked: Boolean(props.locked)
        }
    }

    
    getData = () => {
        return this.state.data;
    }
    
    
    componentDidUpdate(oldProps) {
        // Update state when props.data changes
        if (oldProps.data === this.props.data) return;
        const newData = this.props.data ?? {
            country: this.props.meta?.defaults?.country,
            state: this.props.meta?.defaults?.state
        };
        if (deepEqual(this.state.data, newData)) return;
        // Just sync local state – no callback, no props.onChange here
        this.setState({
            data: newData
        });
        
    }
    
    onOptionChange = (e) => {
        const newData = {
            ...this.state.data,
            country: e.target.value === "US" ? "US"
                : this.state.data?.country !== "US" ? this.state.data?.country
                    : e.target.value,
            state: e.target.value === "US"
                ? this.state.data?.state || this.props.meta?.defaults?.state
                : null,
        };

        this.setState({ data: newData }, () => {
            if (this.props.onChange) {
                this.props.onChange(newData);
            }
        });
    }

    onChange = (e) => {
        const newData = {
            ...this.state.data,
            [e.target.name]: e.target.value
        };

        if (newData === this.state.data) return;

        this.setState({ data: newData }, () => {
            if (this.props.onChange) {
                this.props.onChange();
            }
        });
    }
    
    onCountryChange = (e) => {
        if (CountryValid(this.state.data.country, e.value)) {
            this.onChange({ target: { name: "country", value: e.value } });
        }
    }

    onStateChange = (e) => {
        if (StateValid(e.value)) {
            this.onChange({ target: { name: "state", value: e.value } });
        }
    }

    onCountyChange = (e) => {
        if (CountyValid(this.state.data.state, e.value)) {
            this.onChange({ target: { name: "county", value: e.value } });
        }
    }

    render() {
        return (
            <>
                {this.state.label ?
                    <Row className="g-3">
                        <Col lg="12">
                            <h2 className="small-title">{this.state.label}</h2>
                        </Col>
                    </Row>
                    : ``}
                <Row className="g-3 mb-3">
                    <Col lg="3" className="d-flex">
                        <OptionCard name="countryCode" value="US" checked={this.state.data?.country === "US"} onChange={this.state.locked ? null : this.onOptionChange} iconClassName="imaps-usa-map" iconClassColor="black" iconFontSize="48px" caption={this.state?.configuration?.captions["US"]}  />
                    </Col>
                    {this.state.data?.country === "US" ? (
                        <Col lg="4">
                            <Row>
                                <Col lg="12">
                                    <div className="mb-3 top-label">
                                        <Form.Control value={this.state.data?.city || ""} type="text" name="city" onChange={this.onChange} readOnly={this.state.locked} />
                                        <Form.Label>CITY</Form.Label>
                                    </div>
                                </Col>
                                <Col lg="12">
                                    <div className="mb-3 top-label">
                                        {(this.state.locked) ?
                                            <Form.Control type="text" name="state" value={StateLabel(this.state.data?.state) || ""} readOnly={true} />
                                            :
                                            <StateSelect value={this.state.data?.state || ""} onChange={this.onStateChange} placeholder="" name="state" />
                                        }
                                        <Form.Label>STATE</Form.Label>
                                    </div>
                                </Col>
                                <Col lg="12">
                                    <div className="mb-3 top-label">
                                        {(this.state.locked) ?
                                            <Form.Control type="text" name="county" value={this.state.data?.county || ""} readOnly={true} />
                                            :
                                            <CountySelect value={this.state.data?.county || ""} state={this.state.data.state} onChange={this.onCountyChange} placeholder="" name="county" />
                                        }
                                        <Form.Label>COUNTY</Form.Label>
                                    </div>
                                </Col>
                            </Row>
                        </Col>
                    ) : ``}
                    <Col lg="3" className="d-flex">
                        <OptionCard name="countryCode" value="OT" checked={this.state.data?.country !== "US"} onChange={this.state.locked ? null : this.onOptionChange} iconClassName="imaps-globe-earth" iconClassColor="black" iconFontSize="48px" caption={this.state?.configuration?.captions["OT"]} />
                    </Col>
                    {this.state.data?.country !== "US" ? (
                        <Col lg="4">
                            <Row>
                                <Col lg="12">
                                    <div className="mb-3 top-label">
                                        <Form.Control value={this.state.data?.city || ""} type="text" name="city" onChange={this.onChange} readOnly={this.state.locked} />
                                        <Form.Label>CITY</Form.Label>
                                    </div>
                                </Col>
                                <Col lg="12">
                                    <div className="mb-3 top-label">
                                        {(this.state.locked) ?
                                            <Form.Control type="text" name="country" value={CountryLabel(this.state.data?.country) || ""} readOnly={true} />
                                            :
                                            <CountrySelect value={this.state.data?.country || ""} onChange={this.onCountryChange} placeholder="" name="country" />
                                        }
                                        <Form.Label>COUNTRY</Form.Label>
                                    </div>
                                </Col>
                            </Row>
                        </Col>
                    ) : ``}
                </Row>
            </>
        )
    }
}

export default Location;